<script lang="ts">
    import {CurrentAuthService, WalkerService} from 'shared/services';
    import {getInjector, getLocalization} from 'src/core';

    const localize = getLocalization();
    const currentAuthService = getInjector().getByClass(CurrentAuthService);
    const walker = getInjector().getByClass(WalkerService);
    const currentAuth$ = currentAuthService.currentAuth$();

    $: isAuthenticated = $currentAuth$.role.includes('ROLE_EXTERNALLY_AUTHENTICATED');

    function redirect() {
        walker.newPage('/login/oauth2/code/bankid', {redirect: window.location.href});
    }
</script>

<div class="login-system login-system-bankid">
    {#if isAuthenticated}
        <div>
            BankID {$currentAuth$.activeUser.text}
        </div>
    {:else}
        <button class="btn btn-primary btn-block btn-bankid-login"
                data-qa="bankid-login-button"
                on:click={redirect}>
            {localize(/* @kp-localization login.bankid.LoginViaBankID */ 'login.bankid.LoginViaBankID')}
        </button>
    {/if}
</div>

<style lang="less">
    .btn-bankid-login {
        color: #000000;
        background-color: #FFFFFF;
        border-color: #000000;
    }

    .btn-bankid-login:hover,
    .btn-bankid-login:focus {
        background-color: #F0EFFD;
        color: #000000;
    }

    .btn-bankid-login:active {
        background-color: #F0EFFD;
        color: #000000;
    }
</style>